export enum VisibilityMode {
    ALWAYS_VISIBLE,
    VISIBLE_IF_ALL_CONDITIONS,
    VISIBLE_IF_AT_LEAST_ONE_CONDITION,
    VISIBLE_IF_ANOTHER_FIELD_VISIBLE
}
